<div class="row align-items-center">
  <div class="col">
    @for (text of texts; track text) {
      {{ text[0] | translate: text[1]}}<br />
    }
  </div>
</div>
<div class="row align-items-center">
  <div class="col text-right">
    <button mat-raised-button color="primary" (click)="dismiss()">{{ 'Common.Ok' | translate }}</button>
  </div>
</div>